
export default {
  data () {
    return {}
  },
  computed: {
    // ---------------------------------------------------------//
    // Reseller id from sales system
    // ---------------------------------------------------------//
    resellerId () {
      return process.env.VUE_APP_RESELLER_ID
    },
    resellerIdAsNumber () {
      const id = Number(process.env.VUE_APP_RESELLER_ID)
      if (id == 'NaN') {
        return -1
      }
      return id;
    },
    // ---------------------------------------------------------//
    // Base url for the api
    // ---------------------------------------------------------//
    baseUrl () {
      return process.env.VUE_APP_API_BASE_URL
    }
  }
}
